import { render } from "./Info.vue?vue&type=template&id=22162d4c&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=22162d4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22162d4c"

export default script